import { MongoSchema } from "../MongoSchema";

export class SchemaFieldValidationError extends Error
{
	constructor(field: string, _message: string)
	{
        super(_message + " (Field: '" + field + "')");
	}

};
